import { DateTimeHelper } from "src/app/core/helper/datetime.helper";

export class PushMessage {
    message: string;
    sentAt: string
    auctionId: number;
    productId: number;
    pushMessageId: number;

    private _sentAtString: string;
    get sentAtString() { return this._sentAtString; }

    public constructor(pushMessage?: Partial<PushMessage>) {
        Object.assign(this, pushMessage);
        const sentDate = new Date(this.sentAt);
        this._sentAtString = DateTimeHelper.formatDate(sentDate);

    }
}
